import cx from 'classnames';
import { ListItem, List } from '@mui/material';

import { makeStyles } from '@mui/styles';

import { HEIGHT } from '../ContextSwitcher/constants';
import SelectableItem from './SelectableItem';

const useStyles = makeStyles(
  ({ palette, spacing }) => ({
    root: {
      padding: spacing(1),
      minWidth: 240,
      overflow: 'auto',
      '& +$root': {
        borderTop: `1px solid ${palette.layout.line.divider}`,
      },
    },
    childrenItem: {
      width: '100%',
      padding: spacing(1),
      color: 'inherit',
      borderRadius: 4,
      marginTop: 0,
    },
    compactContainer: {
      maxHeight: 240,
    },
  }),
  { classNamePrefix: 'SelectableItemList' }
);

export default function SelectableItemList({
  children = null,
  listComponent: ListComponent = List,
  itemComponent: ItemComponent = 'li',
  items,
  selectedItemValue = null,
  onChange = /* istanbul ignore next */ () => {},
  canClickOnSelected = false,
  size = HEIGHT.UNSET,
}) {
  const classes = useStyles();

  const getOnItemClick = (item) => () => {
    onChange(item);
  };

  return (
    <ListComponent
      className={cx(classes.root, {
        [classes.compactContainer]: size === HEIGHT.COMPACT,
      })}
    >
      {items
        .filter(({ label }) => Boolean(label))
        .map(({ value, label, ...otherProps }) => {
          const isSelected = value === selectedItemValue || otherProps.isSelected;

          const listItemProps =
            isSelected && !canClickOnSelected
              ? otherProps
              : {
                  onClick: getOnItemClick({ value, label }),
                  ...otherProps,
                };

          return (
            <SelectableItem
              key={label}
              label={label}
              isSelected={isSelected}
              component={ItemComponent}
              {...listItemProps}
            />
          );
        })}
      {children && <ListItem className={classes.childrenItem}>{children}</ListItem>}
    </ListComponent>
  );
}
